export enum Platform {
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
}
